export default __webpack_public_path__ + "static/media/invoice-logo.c7478794.png";